import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

function formatDate(isoStr) {
  if (!isoStr) return "";
  const d = new Date(isoStr);
  return d.toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" });
}

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetch(`${API}/blog/${slug}`)
      .then(r => {
        if (!r.ok) { setNotFound(true); setLoading(false); return null; }
        return r.json();
      })
      .then(data => { if (data) { setPost(data); setLoading(false); } })
      .catch(() => { setNotFound(true); setLoading(false); });
  }, [slug]);

  if (loading) {
    return (
      <main style={{ paddingTop: "72px", minHeight: "80vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <p style={{ fontFamily: "'Noto Serif Ethiopic', Georgia, serif", fontStyle: "italic", fontSize: "28px", color: "#6D5E56" }}>Chargement...</p>
      </main>
    );
  }

  if (notFound || !post) {
    return (
      <main style={{ paddingTop: "72px", minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: "24px" }}>
        <h1 style={{ fontFamily: "'Noto Serif Ethiopic', Georgia, serif", fontSize: "2rem", fontWeight: 300, color: "#3D1602" }}>Article non trouvé</h1>
        <Link to="/blog" className="btn-outline-dark">Retour au blog</Link>
      </main>
    );
  }

  return (
    <main className="page-fade" data-testid="blog-post-page" style={{ paddingTop: "72px" }}>

      {/* Hero image */}
      <section style={{ height: "50vh", position: "relative", overflow: "hidden" }}>
        <img
          src={post.image_url}
          alt={post.title}
          style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "center" }}
        />
        <div style={{ position: "absolute", inset: 0, backgroundColor: "rgba(30,10,2,0.45)" }} />
        <div style={{
          position: "absolute", bottom: "48px", left: "50%",
          transform: "translateX(-50%)",
          textAlign: "center", width: "90%", maxWidth: "700px",
        }}>
          <span style={{ fontSize: "9px", letterSpacing: "4px", textTransform: "uppercase", color: "rgba(61,22,2,0.6)", marginBottom: "12px", display: "block" }}>
            {post.category} · {formatDate(post.created_at)}
          </span>
          <h1 style={{
            fontFamily: "'Noto Serif Ethiopic', Georgia, serif",
            fontSize: "clamp(1.8rem, 4vw, 3rem)",
            fontWeight: 300, color: "#3D1602",
            lineHeight: 1.2,
          }}>
            {post.title}
          </h1>
        </div>
      </section>

      {/* Article content */}
      <section style={{ padding: "80px 24px", backgroundColor: "#F7F3EA" }}>
        <div style={{ maxWidth: "720px", margin: "0 auto" }}>

          {/* Excerpt / intro */}
          <div style={{ borderLeft: "2px solid #E9DCC4", paddingLeft: "24px", marginBottom: "48px" }}>
            <p style={{
              fontFamily: "'Noto Serif Ethiopic', Georgia, serif", fontStyle: "italic",
              fontSize: "20px", color: "#6D5E56",
              lineHeight: 1.7
            }}>
              {post.excerpt}
            </p>
          </div>

          {/* Content */}
          <div
            className="blog-content"
            data-testid="blog-content"
            dangerouslySetInnerHTML={{ __html: post.content }}
          />

          {/* Author */}
          <div style={{
            marginTop: "64px",
            paddingTop: "32px",
            borderTop: "1px solid rgba(61,22,2,0.1)",
            display: "flex", alignItems: "center", gap: "20px",
          }}>
            <img
              src="https://customer-assets.emergentagent.com/job_precision-amour/artifacts/vid4snop_IMG_2975.png"
              alt="Laurine"
              style={{ width: "56px", height: "56px", objectFit: "cover", objectPosition: "50% 20%", borderRadius: "50%" }}
            />
            <div>
              <p style={{ fontFamily: "'Noto Serif Ethiopic', Georgia, serif", fontSize: "16px", color: "#3D1602", marginBottom: "2px" }}>Laurine</p>
              <p style={{ fontSize: "10px", letterSpacing: "3px", textTransform: "uppercase", color: "#6D5E56" }}>Fondatrice · ELLAA WEDDING</p>
            </div>
          </div>

          {/* Back link */}
          <div style={{ marginTop: "48px" }}>
            <Link to="/blog" style={{
              fontSize: "10px", letterSpacing: "3px", textTransform: "uppercase",
              color: "#3D1602", textDecoration: "none",
              borderBottom: "1px solid rgba(61,22,2,0.4)", paddingBottom: "2px",
            }}>
              ← Retour au blog
            </Link>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{ padding: "80px 24px", backgroundColor: "#F7F3EA", textAlign: "center" }}>
        <div style={{ maxWidth: "600px", margin: "0 auto" }}>
          <p style={{ fontFamily: "'Noto Serif Ethiopic', Georgia, serif", fontStyle: "italic", fontSize: "24px", color: "rgba(61,22,2,0.6)", marginBottom: "16px" }}>
            Prête à passer à l'action ?
          </p>
          <h2 style={{
            fontFamily: "'Noto Serif Ethiopic', Georgia, serif",
            fontSize: "clamp(1.5rem, 3vw, 2rem)",
            fontWeight: 300, color: "#3D1602", marginBottom: "32px",
          }}>
            Planifions votre mariage ensemble.
          </h2>
          <a href="https://calendly.com/ellaa-wedding/30min" target="_blank" rel="noopener noreferrer"
            data-testid="blog-post-cta" className="btn-primary">
            Planifier un appel découverte
          </a>
        </div>
      </section>
    </main>
  );
}
